import { render } from "./Aftersale.vue?vue&type=template&id=1082b056&scoped=true"
import script from "./Aftersale.vue?vue&type=script&lang=js"
export * from "./Aftersale.vue?vue&type=script&lang=js"

import "./Aftersale.vue?vue&type=style&index=0&id=1082b056&scoped=true&lang=scss"

import exportComponent from "D:\\sycode\\ijj-web\\iseso-mall-pc-vue3\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1082b056"]])

export default __exports__